// Site-wide constants. Anything used in 2+ places that isn't more
// naturally a config value, env var, or per-feature option lives
// here so it's diffable + searchable in one place.

import { getMode, type CityDailyConfig } from '@atlasguess/games';

/** Milliseconds in a day. Used for "X days ago" math on banners + stats. */
export const MS_PER_DAY = 86_400_000;

/**
 * The flagship game mode — what `/leaderboard` ranks and what the
 * stats hero features. Single source of truth so a future flagship
 * rotation only changes here. Mirrors `App\Support\ModeId::FLAGSHIP`
 * on the backend.
 */
export const FLAGSHIP_MODE_ID = 'cities-world-daily';

/**
 * Number of rounds per daily run, derived from the registered
 * flagship config so the constant follows the source of truth — if
 * the flagship ever changes round count, the per-round-average
 * display surfaces (stats card, leaderboard user-rank chip, public
 * profile) pick up the new denominator without code changes here.
 *
 * Falls back to 5 if the flagship lookup fails (e.g. mid-refactor).
 * The `as` cast is safe by construction — flagship is always a
 * city-daily config, registered at module load.
 */
const flagshipMode = getMode(FLAGSHIP_MODE_ID) as CityDailyConfig | undefined;
export const DAILY_ROUND_COUNT = flagshipMode?.rounds ?? 5;
